var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMovies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSketch: "http://www.bohemiancoding.com/sketch/ns",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    sketchType: "MSPage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screens/review",
    sketchType: "MSArtboardGroup",
    transform: "translate(-409.000000, -30.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    sketchType: "MSLayerGroup",
    transform: "translate(47.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "movie",
    transform: "translate(353.000000, 20.000000)",
    sketchType: "MSShapeGroup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(8.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,11 L2,20 C2,21.1 2.9,22 4,22 L20,22 C21.1,22 22,21.1 22,20 L22,11 L2,11 Z",
    id: "movie"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25881905,9.96592583 L1.25881905,4.96592583 C1.25881905,3.86592583 2.15881905,2.96592583 3.25881905,2.96592583 L4.25881905,2.96592583 L6.25881905,6.96592583 L9.25881905,6.96592583 L7.25881905,2.96592583 L9.25881905,2.96592583 L11.258819,6.96592583 L14.258819,6.96592583 L12.258819,2.96592583 L14.258819,2.96592583 L16.258819,6.96592583 L19.258819,6.96592583 L17.258819,2.96592583 L21.258819,2.96592583 L21.258819,9.96592583 L1.25881905,9.96592583 Z",
    id: "movie",
    transform: "translate(11.258819, 6.465926) rotate(-15.000000) translate(-11.258819, -6.465926) "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovies);
export default __webpack_public_path__ + "static/media/movies.9fc371dcde2e720914ecc1a984acfd27.svg";
export { ForwardRef as ReactComponent };